export interface INotificationsContactInfoSchema {
    name: string;
    email: string;
    phone: string;
}
